import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Truck, MapPin, Clock, Package } from 'lucide-react';

export default function LivraisonPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen pt-28 pb-20 bg-brand-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <span className="font-accent text-brand-gold text-sm tracking-[0.3em] uppercase">{t('deliveryPage.options')}</span>
          <h1 className="font-heading text-4xl lg:text-5xl font-bold text-brand-black mt-2">{t('deliveryPage.title')}</h1>
          <p className="text-brand-dark/60 mt-4">{t('deliveryPage.subtitle')}</p>
        </motion.div>

        <div className="space-y-8">
          {/* Zones de livraison */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-brand-cream border border-brand-gold/20 rounded-lg p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <MapPin className="h-6 w-6 text-brand-gold" />
              <h2 className="font-heading text-2xl text-brand-black">{t('deliveryPage.zones')}</h2>
            </div>
            
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-brand-white p-4 rounded border border-brand-gold/20">
                <p className="text-brand-black font-semibold">{t('deliveryPage.zone1')}</p>
                <p className="text-brand-gold font-bold text-xl">$5.00 CAD</p>
              </div>
              <div className="bg-brand-white p-4 rounded border border-brand-gold/20">
                <p className="text-brand-black font-semibold">{t('deliveryPage.zone2')}</p>
                <p className="text-brand-gold font-bold text-xl">$10.00 CAD</p>
              </div>
              <div className="bg-brand-white p-4 rounded border border-brand-gold/20">
                <p className="text-brand-black font-semibold">{t('deliveryPage.zone3')}</p>
                <p className="text-brand-gold font-bold text-xl">$15.00 CAD</p>
              </div>
              <div className="bg-brand-white p-4 rounded border border-brand-gold/20">
                <p className="text-brand-black font-semibold">{t('deliveryPage.zone4')}</p>
                <p className="text-brand-gold font-bold text-xl">$25.00 CAD</p>
              </div>
            </div>
          </motion.div>

          {/* Home Delivery */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-brand-cream border border-brand-gold/20 rounded-lg p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <Truck className="h-6 w-6 text-brand-gold" />
              <h2 className="font-heading text-2xl text-brand-black">{t('deliveryPage.homeDelivery')}</h2>
            </div>
            <p className="text-brand-dark/80">{t('deliveryPage.homeDeliveryDesc')}</p>
          </motion.div>

          {/* Canada Post */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="bg-red-50 border border-red-200 rounded-lg p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <Clock className="h-6 w-6 text-red-600" />
              <h2 className="font-heading text-2xl text-red-700">{t('deliveryPage.canadaPost')} - $15.00 CAD</h2>
            </div>
            <p className="text-brand-dark/80">{t('deliveryPage.canadaPostDesc')}</p>
          </motion.div>

          {/* Retrait */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-green-50 border border-green-200 rounded-lg p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <Package className="h-6 w-6 text-green-600" />
              <h2 className="font-heading text-2xl text-green-700">{t('deliveryPage.pickup')} - {t('checkout.free').toUpperCase()}</h2>
            </div>
            <p className="text-brand-dark/80 mb-4">{t('deliveryPage.pickupDesc')}</p>
            <div className="bg-brand-white p-4 rounded border border-green-200">
              <p className="text-brand-black font-semibold">130 Topham Terrace</p>
              <p className="text-brand-dark/80">Orléans, ON</p>
              <p className="text-green-600 font-medium mt-2">{t('deliveryPage.processingTimeDesc')}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
